'use client';

import { useRouter } from 'next/navigation';
import { useTransition } from 'react';

import { SortMenu } from '@eliadmin/core/src/components/nt/category/listing/listing-sort';
import { cn } from '@eliadmin/core/src/utils/style-utils';

import type { BlogSort as BlogSortValue } from './blog-list-state';

export type BlogSortOption = { value: BlogSortValue; label: string; href: string };

/**
 * Figma „Zoradiť: Najnovšie ▾“ (248:14822 filters row): Body/M #363D36 + Body/M Bold #0D110D and the
 * caret (14 px, 16 on phones) – the category sort menu (`SortMenu`); a choice goes to its URL
 * (`?sort=most-read`) in place – the list re-renders on the server, the scroll stays.
 */
export function BlogSort({
  label,
  value,
  options,
  className,
}: {
  /** „Zoradiť:“ */
  label: string;
  value: BlogSortValue;
  options: BlogSortOption[];
  className?: string;
}) {
  const router = useRouter();
  const [isPending, startTransition] = useTransition();

  return (
    <SortMenu
      label={label}
      value={value}
      options={options}
      onChange={next => {
        const option = options.find(item => item.value === next);
        if (option) startTransition(() => router.push(option.href, { scroll: false }));
      }}
      busy={isPending}
      className={cn('gap-1.5', className)}
      valueClassName="nt-body-m-bold"
      iconClassName="md:size-3.5"
    />
  );
}
